import {inject, Injectable} from '@angular/core';
import {CityStore} from './stores/city.store';
import {forkJoin} from 'rxjs';
import {ParcelStatusStore} from './stores/parcel-status.store';
import {ParcelTypeStore} from './stores/parcel-type.store';
import {BusStationStore} from './stores/bus-station.store';
import {DepartureTypeStore} from './stores/departure-type.store';
import {PassengerCategoryStore} from './stores/passenger-category.store';
import {CommandStatusStore} from './stores/command-status.store';
import {BusBrandStore} from './stores/bus-brand.store';
import {BusTypeStore} from './stores/bus-type.store';
import {FuelTypeStore} from './stores/fuel-type.store';

@Injectable({
  providedIn: 'root',
})
export class StoreManagerService {
  private citiesStore = inject(CityStore);
  private parcelTypeStore = inject(ParcelTypeStore);
  private busStationStore = inject(BusStationStore);
  private departureTypeStore = inject(DepartureTypeStore);
  private passengerCategoryStore = inject(PassengerCategoryStore);
  private commandStatusStore = inject(CommandStatusStore);
  private busBrandStore = inject(BusBrandStore);
  private busTypeStore = inject(BusTypeStore);
  private fuelTypeStore = inject(FuelTypeStore);
  private stores = [
    this.citiesStore,
    this.parcelTypeStore,
    this.busStationStore,
    this.departureTypeStore,
    this.passengerCategoryStore,
    this.commandStatusStore,
    this.busBrandStore,
    this.busTypeStore,
    this.fuelTypeStore,
  ]

  initializeAllStores() {
    console.log('🚀 Initialisation de tous les stores...');

    return forkJoin({
      cities: this.citiesStore.load(),
      parcelTypes: this.parcelTypeStore.load(),
      busStations: this.busStationStore.load(),
      departureTypes: this.departureTypeStore.load(),
      passengerCategories: this.passengerCategoryStore.load(),
      commandStatus: this.commandStatusStore.load(),
      busBrands: this.busBrandStore.load(),
      busTypes: this.busTypeStore.load(),
      fuelType: this.fuelTypeStore.load(),
    }).subscribe({
      next: (result) => {
        console.log('✅ Tous les stores initialisés:', {
          cities: result.cities.length,
          parcelTypes: result.parcelTypes.length,
          busStations: result.busStations.length,
          departureTypes: result.departureTypes.length,
          passengerCategories: result.passengerCategories.length,
          commandStatus: result.commandStatus.length,
          fuelType: result.fuelType.length,
        });
      },
      error: (error) => {
        console.error('❌ Erreur initialisation stores:', error);
      }
    });
  }

  // ✅ Initialiser seulement certains stores
  initializeStores(storeNames: string[]) {
    console.log('🚀 Initialisation des stores:', storeNames);

    const observables: any = {};

    if (storeNames.includes('cities')) {
      observables.cities = this.citiesStore.load();
    }

    return forkJoin(observables).subscribe({
      next: (result) => {
        console.log('✅ Stores initialisés:', result);
      },
      error: (error) => {
        console.error('❌ Erreur initialisation:', error);
      }
    });
  }

  // ✅ Nettoyer tous les stores
  clearAllStores(): void {
    console.log('🧹 Nettoyage de tous les stores...');

    this.stores.forEach(store => store.clear());

    console.log('✅ Tous les stores nettoyés');
  }

  // ✅ Réinitialiser tous les stores
  resetAllStores(): void {
    this.clearAllStores();
  }

  // ✅ Vérifier l'état de tous les stores
  getStoresStatus() {
    return {
      cities: {
        loaded: this.citiesStore.isLoaded,
        loading: this.citiesStore.isLoading,
        count: this.citiesStore.items.length
      },
      parcelType: {
        loaded: this.parcelTypeStore.isLoaded,
        loading: this.parcelTypeStore.isLoading,
        count: this.parcelTypeStore.items.length
      },
      busStations: {
        loaded: this.busStationStore.isLoaded,
        loading: this.busStationStore.isLoading,
        count: this.busStationStore.items.length
      },
      departureTypes: {
        loaded: this.departureTypeStore.isLoaded,
        loading: this.departureTypeStore.isLoading,
        count: this.departureTypeStore.items.length
      },
      passengerCategories: {
        loaded: this.passengerCategoryStore.isLoaded,
        loading: this.passengerCategoryStore.isLoading,
        count: this.passengerCategoryStore.items.length
      },
      commandStatuses: {
        loaded: this.commandStatusStore.isLoaded,
        loading: this.commandStatusStore.isLoading,
        count: this.commandStatusStore.items.length
      }
    };
  }
}
